import Vue from 'vue';

let els;

if ((els = document.querySelectorAll('.faq')).length > 0) {
	for (let i = 0; i < els.length; i++) {
		const el = els[i];

		new Vue({
			el,
			name: 'FAQ',
			data() {
				return {
					cities: [],
					opened: false,
					form: {
						lastname: '',
						firstname: '',
						postcode: '',
						email: '',
						phone: '',
						subject: '',
						message: '',
						rgpd: ''
					}
				};
			},
			methods: {
				answerHeight(question, index) {
					return this.opened === index ? (this.heights[index] / 10) + 'rem' : 0;
				}
			},
			mounted() {
				this.$refs.answers.forEach((answer, index) => {
					this.heights[index] = answer.getBoundingClientRect().height;
					this.questions[index].init = true;
				})

				this.$nextTick(() => {
					this.opened = false;
				});
			}
		});
	}
}
